import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

/* import HeaderUserTitle from "../components/includes/HeaderUserTitle"; */
import Footer from "../components/includes/Footer";
import { LoginAfterCheckLogin,isNull } from "../../components/common/Common";
import noticeIcon from "../../img/icon/icon-notice.svg";
import inquiryIcon from "../../img/icon/icon-inquiry.svg";
import faqIcon from "../../img/icon/icon-faq.svg";

const MyPage = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const mem_idx = Number(localStorage.getItem('mem_idx'));

  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  const [varMemberInfo,setMemberInfo] = useState({});

  //나의 페이지 정보
  const GetMyPageInformation = async() => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_mypage_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) {
          const parents = datas.results;
          //setMemberList(parents);
          let ch_idx = 0;
          if(!isNull(localStorage.getItem('childrenIndex'))) ch_idx = Number(localStorage.getItem('childrenIndex'));
          //원생 선택
          let childInfo = {};
          if(ch_idx > 0) {
            childInfo = parents.find(el=>el.ch_idx===ch_idx);
          } else {
            childInfo = parents[0];
            //첫번째 자녀(원생) 정보 --> 선택 표시
            ch_idx = parents[0].ch_idx;
            localStorage.setItem('childrenIndex',ch_idx);
          }
          setMemberInfo(childInfo);
        }
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    const newItem = {branchName:"",parentName:"",childrenName:""};
    setMemberInfo(newItem);
    GetMyPageInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content mypage-wrap">
      {/* <HeaderUserTitle varPageTitle={'더보기'} varBackString="none"/> */}
      <div className="vh-content-body" style={{marginTop:"0px"}}>
        <div className="user-info">
          <div className="user-left">
            <div className="center-name">{varMemberInfo.branchName}</div>
            <div className="user-name">{`${varMemberInfo.childrenName}(${varMemberInfo.parentName})`}</div>				
          </div>
          <Link to={'/Parents/MyInfo'} style={{paddingLeft:"10px",paddingRight:"10px"}}>정보수정</Link>
        </div>
        <div className="mypage-con">
          <div className="center-wrap">
            <div className="con con02" style={{marginBottom:"20px"}}>
              <ul>
                <li><Link to={'/Parents/Certificates'}>수료증</Link></li>
              </ul>
            </div>
            <div className="con con01">					
              <ul>
                <li><Link to={'/Parents/Notice'}><img src={noticeIcon} alt=""/>공지사항</Link></li>
                <li><Link to={'/Parents/Question'}><img src={inquiryIcon} alt=""/>1:1문의</Link></li>
                <li><Link to={'/Parents/Faq'}><img src={faqIcon} alt=""/>자주묻는 질문과 답변</Link></li>
              </ul>
            </div>
            <div className="con con02">					
              <ul>
                <li><Link to={'/Parents/Terms/1'}>이용약관</Link></li>
                <li><Link to={'/Parents/Terms/2'}>개인정보 처리방침</Link></li>
                <li><Link to={'/Parents/Terms/3'}>취소/환불 정책 동의</Link></li>
                <li><Link to={'/Parents/Terms/4'}>마케팅 목적의 개인정보 수집 및 이용동의</Link></li>
              </ul>
            </div>
          </div>
				</div>
      </div>
      <Footer varCurrentPage={4}/>
    </div>
  )
}
export default MyPage;